OT.createNS('OT.SearchImpressionAnalytics');

  OT.SearchImpressionAnalytics.init = function() {
    var baseUrl = window.OTSearchData.Display.AnalyticsCollectorUrlOverride;
    var path = '/v2/import';
    var url;

    if(baseUrl) {
      url = baseUrl + path;
    }

    OT.Common.ImpressionsAnalytics.init({
      appName: 'desktop-search',
      logger: console.log,
      parentQuery: '.analytics-results-list',
      query: '.analytics-results-list .result',
      referrer: 'ConsumerWeb',
      url: url
    });
  }

  OT.SearchImpressionAnalytics.init();